import { gql } from '@apollo/client';

/**
 * The full career profile selection (spec 0018, increment B).
 *
 * Shared by `MyCareerProfile` (read) and `SaveCareerProfileForm` (write) so the
 * mutation returns a fresh, complete profile — the save response is used directly
 * as the new form baseline, avoiding a refetch that would clobber in-flight edits.
 *
 * Certificates carry `id` so the FE can round-trip it: the backend reconciles
 * certificates by id (update in place / create / delete), preserving admin files.
 */
export const CAREER_PROFILE_FIELDS = gql`
  fragment CareerProfileFields on CareerProfileType {
    id
    firstName
    lastName
    email
    phone
    photoUrl
    city
    country
    relocationReady
    workMode
    workPermit
    availableFrom
    seniority
    desiredPosition
    desiredSalary
    githubUrl
    linkedinUrl
    portfolioUrl
    customSkills
    isSearchable
    contactsVisible
    completeness
    skills {
      skillId
      name
      category
      level
      years
    }
    projects {
      id
      title
      description
      role
      repoUrl
      demoUrl
      technologyIds
      technologyNames
    }
    experience {
      id
      company
      position
      description
      startYear
      startMonth
      endYear
      endMonth
      isCurrent
    }
    education {
      id
      institution
      degree
      specialization
      startYear
      startMonth
      endYear
      endMonth
    }
    languages {
      id
      language
      level
    }
    certificates {
      id
      title
      issuer
      issuedAt
      url
      fileUrl
    }
    locales {
      language
      jobTitle
      about
    }
  }
`;
